<template lang="pug">
  .TheFooterBottomLinks.footer-bottom-links
    DisclaimerDisclosure.footer-bottom-links__link.is--disclosure(
      link-class="link-4 small-link",
    )
      template(slot="linkName")
        span Disclosures
    a.link-4.small-link.footer-bottom-links__link(
      :href="require('doc/AcreTrader.Electronic.Records.and.Signatures.Form.pdf')",
      target="_blank"
    ) Consent for Electronic Delivery
    a.link-4.small-link.footer-bottom-links__link(
      href="/company/privacy#opt-out-of-marketing-communications"
    ) Online Tracking Opt Out
</template>

<script>
import DisclaimerDisclosure from 'Components/DisclaimerDisclosure/DisclaimerDisclosure';

export default {
  name: 'TheFooterBottomLinks',
  components: {
    DisclaimerDisclosure,
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.footer-bottom-links
  margin: 0 -15px
  display: flex
  flex-direction: row
  flex-wrap: wrap
  @media screen and (max-width: 576px)
    flex-direction: column
    align-items: flex-start
  &__link
    display: inline
    margin: 0 15px
    white-space: nowrap
    @media screen and (max-width: 576px)
      margin-bottom: 15px
      &:last-child
        margin-bottom: 0
    &.is--disclosure
      line-height: 17px
</style>
